module.exports = __webpack_public_path__ + "static/media/grid-thumbnail.1eb4ee18.png";